import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PartnersModule } from '@com-delta-idp/mnx-skymiles-partners-ui';
import { SharedModule } from '@com-delta-idp/mnx-skymiles-shared';
import { SkeletonLoaderDirective } from '@com-delta-omnichannel/aura';
import { PushModule } from '@ngrx/component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PartnersEffects } from './data-access/+state/effects/partners.effects';
import * as fromPartners from './data-access/+state/reducers/partners.reducer';
import { PartnersComponent } from './entry-components/partners/partners.component';

@NgModule({
  imports: [
    CommonModule,
    PushModule,
    PartnersModule,
    StoreModule.forFeature(
      fromPartners.PARTNERS_FEATURE_KEY,
      fromPartners.reducer
    ),
    EffectsModule.forFeature([PartnersEffects]),
    SharedModule,
    SkeletonLoaderDirective
  ],
  declarations: [PartnersComponent],
  exports: [PartnersComponent]
})
export class SmartModule {}
